import React from 'react';

/**
 * Vorschaubild „komplett sichtbar, Rest geblurrt“ (Marcel 13.10.2026, wie die Detail-Galerie):
 * unscharfer Hintergrund aus demselben Bild (cover) + Bild selbst in contain.
 */
const BlurredThumb: React.FC<{ src: string; className?: string; alt?: string }> = ({ src, className = '', alt = '' }) => (
  <span className={`relative block overflow-hidden bg-zinc-900 ${className}`} data-testid="blurred-thumb">
    <img src={src} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full scale-110 object-cover opacity-60 blur-md" loading="lazy" />
    <span className="absolute inset-0 bg-black/30" aria-hidden="true" />
    <img src={src} alt={alt} className="relative h-full w-full object-contain" loading="lazy" />
  </span>
);

export default BlurredThumb;
